import { Observable, of } from 'rxjs';
import { GameAttemptResult, GameAttemptSubmission, LessonGamePlay } from 'src/app/models/module/lessongame.model';
import { ClassmanagementService } from 'src/app/services/classmanagement.service';

// Checks a game attempt: on the server when online (the play copy carries no answers), or on
// the device when the game is a copy saved for offline use, which carries its answer key.
// Nothing is persisted either way - these games are ungraded practice
// (ClassUtility.SubmitGameAttempt).
export function checkGameAttempt(game: LessonGamePlay, submission: GameAttemptSubmission, classmanager: ClassmanagementService): Observable<GameAttemptResult> {
  if (game.answers) return of(gradeLocally(game, submission));
  return classmanager.submitGameAttempt(submission);
}

// A line-for-line port of ClassUtility.SubmitGameAttempt's rules, so an attempt gets the same
// verdict offline as online.
export function gradeLocally(game: LessonGamePlay, submission: GameAttemptSubmission): GameAttemptResult {
  const result = new GameAttemptResult();

  if (game.gameType === 'match') {
    const pairs = game.answers?.pairs ?? [];
    const submitted = submission.matches ?? [];
    for (const pair of pairs) {
      const answer = submitted.find((m) => m.termId === pair.termId);
      const correct = !!answer && answer.defId === pair.defId;
      (correct ? result.correctTermIds : result.incorrectTermIds).push(pair.termId);
    }
    result.allCorrect = result.incorrectTermIds.length === 0 && result.correctTermIds.length === pairs.length;
    result.correctPairs = pairs.map((p) => ({ term: p.term, definition: p.definition }));
  } else if (game.gameType === 'sequence') {
    const correctOrder = game.answers?.orderedSteps ?? [];
    const submittedOrder = submission.orderedStepIds ?? [];
    result.allCorrect = submittedOrder.length === correctOrder.length && submittedOrder.every((id, i) => id === correctOrder[i].id);
    result.correctOrder = correctOrder.map((s) => s.text);
  } else {
    // Flashcard: every card must have been confirmed ("Got it").
    const confirmed = submission.confirmedCardIds ?? [];
    result.pendingCardIds = (game.cards ?? []).filter((c) => !confirmed.includes(c.id)).map((c) => c.id);
    result.allCorrect = result.pendingCardIds.length === 0;
  }
  return result;
}
